/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanRemoveFixedCostRequestDto
 */
export interface MonthPlanRemoveFixedCostRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanRemoveFixedCostRequestDto
   */
  fundId: string;
}

export function MonthPlanRemoveFixedCostRequestDtoFromJSON(json: any): MonthPlanRemoveFixedCostRequestDto {
  return MonthPlanRemoveFixedCostRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanRemoveFixedCostRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanRemoveFixedCostRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
  };
}

export function MonthPlanRemoveFixedCostRequestDtoToJSON(value?: MonthPlanRemoveFixedCostRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
  };
}
